import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class JanelaRenuncia extends BaseEntity {
    id: number;
    dataInicioVigencia: Date;
    dataFimVigencia: Date;
    dataCriacao: Date;
    usuarioResponsavelCadastroJanela: string;
    apurado: boolean;
    tipoJanela: string
}